import { call, put, takeEvery } from "redux-saga/effects";
import requestWithSubTenantIfNeeded from "../requestWithSubTenantIfNeeded";
import * as actions from "@p81-common/shell-core-js/dist/redux/applicationsSettingsGet";
import {
  SOCKET_EVENT_APPLICATION_REMOVE_SUCCESS,
  SOCKET_EVENT_APPLICATION_ADD_SUCCESS,
  SOCKET_EVENT_APPLICATION_UPDATE_SUCCESS,
} from "../networksBeaconsGet/networksBeaconsGetActions";
import { concatWith, modifyApplicationDefaultIconUrl, sortField , decode} from "@p81-common/shell-core-js";

export function sortFavoriteApps(data, favoriteApps) {
  let sortedApplications = [];

  favoriteApps.forEach((appId) => {
    let appIdx = data.findIndex((app) => app.id === appId);
    if (appIdx > -1) {
      sortedApplications.push(...data.splice(appIdx, 1));
    }
  });

  // Sort the favorite applications by the specified sorting field, currently 'name'
  sortedApplications.sort((a, b) => a[sortField].localeCompare(b[sortField]));

  // Push the remaining applications to the sorted list
  sortedApplications.push(...data);

  return sortedApplications;
}

function* applicationsSettingsGet(action) {
  try {
    let params = action.params || decode()(window.location.search);
    let response = yield call(
      requestWithSubTenantIfNeeded,
      "get",
      "applications/settings",
      {
        searchParams: {
          ...params,
          ...(params.q
            ? {
                q: JSON.stringify({
                  name: params.q,
                }),
                qType: "partial",
              }
            : {}),
        },
      }
    );

    let {
      applications,
      relationships: { favoriteApplications = [], applicationGroups },
    } = response.data;

    applications.data.forEach((application) => {
      application.groups = applicationGroups?.filter(({ applications }) =>
        applications.includes(application.id)
      );
      application.users.forEach((member) => {
        member.fullName = concatWith(" ", member.firstName, member.lastName);
      });
      application.isFavorite = favoriteApplications.includes(application.id);

      modifyApplicationDefaultIconUrl(application);
    });

    applications.data = sortFavoriteApps(
      applications.data,
      favoriteApplications
    );

    yield put(actions.requestSuccess(response.data));
  } catch (e) {
    yield put(actions.requestFailure(e));
  }
}

function* saga() {
  yield takeEvery(
    [
      actions.APPLICATIONS_SETTINGS_GET_REQUEST,
      SOCKET_EVENT_APPLICATION_REMOVE_SUCCESS,
      SOCKET_EVENT_APPLICATION_ADD_SUCCESS,
      SOCKET_EVENT_APPLICATION_UPDATE_SUCCESS,
    ],
    applicationsSettingsGet
  );
}

export default saga;
